import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// One chat bubble. User messages stay plain text; assistant replies are Markdown.
const FushiMessage = ({ message }) => {
  const isUser = message.role === "user";

  if (isUser) {
    return (
      <div className="fushi-msg-row flex justify-end">
        <div className="fushi-bubble-user max-w-[85%] rounded-2xl rounded-br-md px-3.5 py-2.5 text-[14px] text-white">
          <span className="whitespace-pre-wrap break-words">{message.content}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="fushi-msg-row flex justify-start">
      <div
        className={`fushi-bubble-bot max-w-[85%] rounded-2xl rounded-bl-md px-3.5 py-2.5 text-[14px] text-text-primary ${
          message.isError ? "fushi-bubble-error" : ""
        }`}
      >
        <div className="fushi-markdown break-words">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: (props) => <a target="_blank" rel="noopener noreferrer" {...props} />,
            }}
          >
            {message.content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default FushiMessage;
